import type { ParentAction, PaymentActionPromise } from '../services/billingApi';

/** O que a efetivação faz com as outras faturas. Sem `_ALL`, só a fatura anterior; com `_ALL`,
 *  todas as faturas abertas do título. */
export const PAYMENT_ACTION_PROMISE_LABELS: Record<PaymentActionPromise, string> = {
    NOTHING: 'Nada — as outras faturas continuam como estão',
    CANCEL: 'Cancelar a fatura anterior',
    CANCEL_ALL: 'Cancelar as outras faturas abertas do título',
    UNCOLLECT: 'Deixar de cobrar a fatura anterior',
    UNCOLLECT_ALL: 'Deixar de cobrar as outras faturas abertas do título',
};

export const paymentActionPromiseLabel = (promise: string | null | undefined): string =>
    (promise && PAYMENT_ACTION_PROMISE_LABELS[promise as PaymentActionPromise]) || promise || '-';

/** A escolha da coluna "Cobrança anterior" da tela de Pagamentos, sem o escopo (AF-4062). */
export const PARENT_ACTION_LABELS: Record<ParentAction, string> = {
    CANCEL: 'Cancelar',
    UNCOLLECT: 'Parar de Cobrar',
    KEEP: 'Manter',
};

export const PARENT_ACTION_ITEMS = (Object.keys(PARENT_ACTION_LABELS) as ParentAction[])
    .map(value => ({ value, label: PARENT_ACTION_LABELS[value] }));
